import { parsePhoneNumberFromString } from 'libphonenumber-js'

const emailRegExp = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/

export function validateEmail(emailString) {
  return emailRegExp.test(emailString)
}

export function removePlusFromBeginning(inputString) {
  if (!inputString) return undefined
  return inputString.startsWith('+') ? inputString.substring(1) : inputString
}

const groupNationalNumber = (digits) => {
  if (!digits) return digits
  if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`
  }
  return digits
}

export const formatPhoneNumber = (phoneString) => {
  if (!phoneString || typeof phoneString !== 'string') {
    return { concatenatedString: phoneString }
  }

  const trimmed = phoneString.trim()
  let countryCode = null
  let nationalNumber = null
  try {
    const parsed = parsePhoneNumberFromString(trimmed)
    if (parsed?.countryCallingCode && parsed?.nationalNumber) {
      countryCode = String(parsed.countryCallingCode)
      nationalNumber = String(parsed.nationalNumber)
    }
  } catch (error) {
    // Fall through to the legacy-compatible regex handling below.
  }

  if (!countryCode || !nationalNumber) {
    const match = trimmed.match(/^\+(\d{1,3})(\d{3})(\d{3})(\d{4})$/)
    if (!match) {
      const format2Match = trimmed.match(/^\+(\d{1,3})(\d{5})(\d{5})$/)
      if (format2Match) {
        const cc = format2Match[1]
        return {
          countryCodeWithoutPlus: cc,
          countryCode: `+${cc}`,
          phoneNumber: `${format2Match[2]}${format2Match[3]}`,
          formattedPhoneNumber: `${format2Match[2]}-${format2Match[3]}`,
          concatenatedString: `(+${cc}) ${format2Match[2]}-${format2Match[3]}`,
          format2CountryCode: cc,
          formatType2Number: `+${cc}-${format2Match[2]}-${format2Match[3]}`,
        }
      }
      return { concatenatedString: phoneString }
    }
    countryCode = match[1]
    nationalNumber = `${match[2]}${match[3]}${match[4]}`
  }

  const formattedPhoneNumber = groupNationalNumber(nationalNumber)
  const formatType2Number = nationalNumber.length === 10
    ? `+${countryCode}-${nationalNumber.slice(0, 5)}-${nationalNumber.slice(5)}`
    : `+${countryCode}-${nationalNumber}`

  return {
    countryCodeWithoutPlus: countryCode,
    countryCode: `+${countryCode}`,
    phoneNumber: nationalNumber,
    formattedPhoneNumber,
    concatenatedString: `(+${countryCode}) ${formattedPhoneNumber}`,
    format2CountryCode: countryCode,
    formatType2Number,
  }
}
